import { FC, Fragment } from "react";
import CardMemberProfile from "../cardMemberProfile";
import FilterMenuSearch from "../filterMenuSearch";
import InfiniteScroller from "../infiniteScroller";

import { Member } from "../../backendProxies";
import NoMatchFound from "../noMatchFound";
import CardGrid from "../cardGrid";
import LoadingSpinner from "../loadingSpinner";
import useSearch from "../../hooks/useSearch";

import PlaceholderSearchResults from "../placeholderSearchResults";

import BodyAdContainerFlexible from "../bodyAdContainerFlexible";

import useAdColSpanSize from "../../hooks/useAdColSpanSize";
import AdWrapper from "../AdWrapper";

const SearchContainer: FC = () => {
  const { fetchResults, members, isLoading, hasMore, fetchingResults } =
    useSearch();

  const adColSpanSize = useAdColSpanSize();

  return (
    <>
      <div className="flex flex-col mt-4 mb-6 space-y-4">
        <FilterMenuSearch />
        {members.length === 0 && !isLoading && <NoMatchFound />}
        {members.length === 0 && isLoading && (
          <PlaceholderSearchResults numberOfResults={20} />
        )}
        {members.length !== 0 && (
          <CardGrid>
            {members.map((member: Member, index: number) => {
              if (index % 8 === 0 && index !== 0) {
                return (
                  <Fragment key={index}>
                    <AdWrapper>
                      <div
                        className={`col-span-${adColSpanSize} md:h-[330px] h-[224px]`}
                      >
                        <BodyAdContainerFlexible googleid="5890572302" />
                      </div>
                    </AdWrapper>

                    <CardMemberProfile key={index} member={member} />
                  </Fragment>
                );
              }
              return <CardMemberProfile key={index} member={member} />;
            })}
          </CardGrid>
        )}
      </div>
      {isLoading && (
        <div className="w-full flex justify-center">
          <LoadingSpinner />
        </div>
      )}

      {hasMore && !isLoading && (
        <div>
          <InfiniteScroller setShouldLoad={() => fetchResults(false)} />
        </div>
      )}

      {fetchingResults && (
        <div className="fixed bottom-2 right-2 z-50">
          <LoadingSpinner />
        </div>
      )}
    </>
  );
};

export default SearchContainer;
